const isOneTrustFunctionalCookieEnabled = () => !!window?.OnetrustActiveGroups?.includes('C0003');

export default isOneTrustFunctionalCookieEnabled;
